<template>
	<div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
                <div class="container-fluid">
                    
					<div class="row align-items-center">
						<div class="col">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/siswa/profile-settings">Home</router-link></li>
									<li class="breadcrumb-item active"><router-link to="/siswa/paket-saya">Paket Saya</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">{{paket.nama_paket}}</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Paket Saya</h2>
						</div>
						<div class="col-auto text-right float-right ml-auto">
							<a href="#" class="btn btn-primary btn-sm"><router-link to="/siswa/paket-saya">Kembali</router-link></a>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
                
				<div class="container">

					<div class="row">
						
						<!-- Profile Sidebar -->
						<!-- <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
							<Sidebar />
						</div> -->
						<!-- / Profile Sidebar -->
						
						<div class="col-md-4 col-lg-12 col-xl-12">

                            <!-- Librarian Widget -->
                            <div class="card">
                                <div class="card-body">
                                    <div class="sender-widget">
                                        <div class="doc-info-left">
                                            <div class="sender-img">
                                                <img v-bind:src="paket.url_gambar" class="img-fluid" alt="User Image">
                                            </div>
                                            <div class="doc-info-cont">
                                                <h4 class="doc-name">{{paket.nama_paket}}</h4>
                                                <p class="doc-department">
                                                    <!-- <img v-bind:src="paket.url_gambar" class="img-fluid" alt="Speciality"> -->
                                                    {{paket.nama_tipe}}</p>
                                                <div class="rating">
                                                    <i class="fas fa-star filled"></i>
                                                    <i class="fas fa-star filled"></i>
                                                    <i class="fas fa-star filled"></i>
                                                    <i class="fas fa-star filled"></i>
                                                    <i class="fas fa-star"></i>
                                                    <!-- <span class="d-inline-block average-rating">(35)</span> -->
                                                </div>
                                                <div class="shop-details">
                                                    <p class="doc-location">{{paket.deskripsi}}</p>
                                                </div>
                                                 <template v-if="paket.fg_rank == '2'">
                                                <div class="shop-services">
                                                    <button data-toggle="modal" data-target="#rankingPaketMdl" class="btn btn-md bg-warning">
                                                        <i class="fa fa-trophy"></i> 
                                                        <template v-if="paket.rankingPaket == '-'">Belum Ada Peringkat</template>
                                                        <template v-if="paket.rankingPaket != '-'">Anda Peringkat ke-{{paket.rankingPaket}}</template>
                                                    </button>                                                    
                                                </div>
                                                 </template>
                                                
                                            </div>
                                        </div>
                                       
                                        <div class="doc-info-right">
                                            <!-- <div class="clini-infos">
                                                <ul>
                                                    <li><i class="far fa-thumbs-up"></i> 99%</li>
                                                    <li><i class="fab fa-whatsapp"></i> 0812-3456-789</li>
                                                    <li><i class="fas fa-clock"></i> 200+ Session </li>
                                                </ul>
                                            </div> -->
                                            <div class="sender-action" v-if="paket.url_telegram != '-'">
                                                <a  :href="paket.url_telegram" target="_blank" class="btn btn-sm bg-primary-light">
                                                    Gabung ke Grup Telegram
                                                </a>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- /Librarian Widget -->
                              
                            <div class="card dash-card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-12 col-lg-4">
                                            <div class="dash-widget dct-border-rht">
                                                <div class="circle-bar circle-bar1">
                                                    <div class="circle-graph1" data-percent="100">
                                                         <!-- :data-percent="paket.materipct">  -->
                                                        <img src="@/assets/img/icon-01.png" class="img-fluid" alt="receiver">
                                                    </div>
                                                </div>
                                                <div class="dash-widget-info">
                                                    <a class="btn btn-sm btn-rounded" :class="{'btn-light': idtab !== 'tabmateri', 'btn-secondary active' : idtab == 'tabmateri'}" href="#tabmateri" data-toggle="tab" @click.prevent="()=>{tabactive='DAFTAR MATERI', idtab='tabmateri', isShowMain = true, isDetailMateri = false}">Materi</a>
                                                    
                                                    <p class="text-muted">{{paket.all_materi}} Total Materi</p>
                                                    <!-- {{paket.finish_materi}} /  -->
                                                    <!-- <p class="text-muted">Till Today</p> -->
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-md-12 col-lg-4">
                                            <div class="dash-widget dct-border-rht">
                                                <div class="circle-bar circle-bar2">
                                                    <div class="circle-graph2" data-percent="100">
                                                         <!-- :data-percent="paket.topct"> -->
                                                        <img src="@/assets/img/icon-02.png" class="img-fluid" alt="Customer">
                                                    </div>
                                                </div>
                                                <div class="dash-widget-info">
                                                    <a class="btn btn-sm btn-rounded" :class="{'btn-light': idtab !== 'tablatihan', 'btn-secondary active' : idtab == 'tablatihan'}" href="#tablatihan" data-toggle="tab"  @click.prevent="()=>{tabactive='DAFTAR TRYOUT', idtab='tablatihan', isShowMain = true, isDetailMateri = false}">Try Out</a>
                                                    <!-- <h6>Kerjakan Try Out</h6> -->
                                                    <p class="text-muted">{{paket.all_to}} Total Latihan</p>
                                                    <!-- {{paket.finish_to}} /  -->
                                                    <!-- <p class="text-muted">2021 2022</p> -->
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-md-12 col-lg-4">
                                            <div class="dash-widget">
                                                <div class="circle-bar circle-bar3">
                                                    <div class="circle-graph3" data-percent="100">
                                                         <!-- data-percent="50"> -->
                                                        <img src="@/assets/img/icon-03.png" class="img-fluid" alt="Customer">
                                                    </div>
                                                </div>
                                                <div class="dash-widget-info">
                                                    <a class="btn btn-sm btn-rounded" :class="{'btn-light': idtab !== 'tabjadwal', 'btn-secondary active' : idtab == 'tabjadwal'}" href="#tabjadwal" data-toggle="tab" @click.prevent="()=>{tabactive='JADWAL BIMBEL', idtab='tabjadwal', isShowMain = true, isDetailMateri = false}">Bimbel</a>
                                                    <!-- <h6>Jadwal Bimbel</h6> -->
                                                    <p class="text-muted">{{paket.all_jadwal}} Jadwal Pertemuan</p>
                                                    <!-- <p class="text-muted">2021 - 2022</p> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <template v-if="isShowMain">
                                <div class="card"  style="min-height:400px">
                                    <div class="card-header"><h4 class="card-title">{{tabactive}}</h4> 
                                    <!-- <p class="card-text">use <code>.btn-rounded</code> in class <code>.btn</code> class to get Rounded button</p> -->
                                    </div>
                                    <div class="card-body">
                                    
                                        <!-- Tab Menu -->
                                        <!-- <nav class="user-tabs mb-4">
                                            <ul class="nav nav-tabs nav-tabs-bottom nav-justified">
                                                <li class="nav-item">
                                                    <a class="nav-link active" data-toggle="tab">{{tabactive}}</a>                                                
                                                </li> 
                                            </ul>
                                        </nav> -->
                                        <!-- /Tab Menu -->
                                        
                                        <!-- Tab Content -->
                                        <div class="tab-content pt-0">
                                        
                                            <div role="tabpanel" id="tabmateri" class="tab-pane fade"  :class="{'show active' : idtab == 'tabmateri'}" >
                                                <div class="row">
                                                    
                                                    <div class="col-md-6" v-for="(item, index) in paket.list_materi" :key="item">
                                                        <div class="card">
                                                            <div class="card-body">
                                                                <div class="sender-widget">
                                                                    
                                                                    <div class="doc-info-left comment">
                                                                        <!-- <div class="sender-img"> -->
                                                                            <img class="avatar rounded-circle" alt="User Image" v-bind:src="((index+1>=22)?'https://img.icons8.com/color/48/undefined/':'https://img.icons8.com/plasticine/100/000000/')+(index+1)+((index+1>9)?'':'-circle')+'.png'" style="margin-right: 16px;">
                                                                        
                                                                            <!-- <router-link to="/profile">
                                                                                <img :src="loadImg(item.image)" class="img-fluid" alt="User Image">
                                                                            </router-link> -->
                                                                        <!-- </div> -->
                                                                        <div class="doc-info-cont comment-body">
                                                                            <h4 class="doc-name"><a href="" @click.prevent="getMateri(item)">{{item.nama_materi}}</a></h4> 
                                                                            <!-- <div class="rating">
                                                                                <i class="fas fa-star filled"></i>
                                                                                <i class="fas fa-star filled"></i>
                                                                                <i class="fas fa-star filled"></i>
                                                                                <i class="fas fa-star filled"></i>
                                                                                <i class="fas fa-star"></i>
                                                                                <span class="d-inline-block average-rating">{{item.ratings}}</span>
                                                                            </div> -->
                                                                            <div class="shop-details">
                                                                                <p class="doc-location"><i class="fas fa-map-marker-alt"></i> {{item.nama_tingkatan}}</p>
                                                                                <!-- <p><i class="fas fa-graduation-cap"></i> {{item.courses}}</p> -->
                                                                            </div>
                                                                            <!-- <div class="shop-services">
                                                                                <span>Dorm Living</span>
                                                                                <span>Diversity & Inclusion</span>
                                                                                <span>Campus Activities</span>
                                                                                <span>Student Support</span>
                                                                            </div> -->
                                                                        </div>
                                                                    </div>
                                                                    
                                                                    <div class="doc-info-right text-center">
                                                                        <div class="table-action">
                                                                            <button class="btn btn-sm btn-secondary mb-0.5"  @click.prevent="getMateri(item)">Lihat Materi</button>
                                                                            
                                                                        </div>
                                                                    </div>  
                                                                </div>
                                                                
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            
                                            </div>
                                            
                                            <div role="tabpanel" id="tablatihan" class="tab-pane fade"  :class="{'show active' : idtab == 'tablatihan'}" >
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="comp-header"><h3 class="comp-title">Daftar Tryout Materi</h3> <div class="line"></div></div>
                                                        <div class="row">
                                                            <div class="col-md-6" v-for="(item, index) in paket.list_tryout_materi" :key="item">
                                                                <div class="card">
                                                                    <div class="card-body">
                                                                        <div class="sender-widget">
                                                                            <div class="doc-info-left comment">
                                                                                <!-- <div class="sender-img"> -->
                                                                                    <img class="avatar rounded-circle" alt="User Image"  v-bind:src="((index+1>=22)?'https://img.icons8.com/color/48/undefined/':'https://img.icons8.com/plasticine/100/000000/')+(index+1)+((index+1>9)?'':'-circle')+'.png'" style="margin-right: 16px;">
                                                                                
                                                                                    <!-- <router-link to="/profile">
                                                                                        <img :src="loadImg(item.image)" class="img-fluid" alt="User Image">
                                                                                    </router-link> -->
                                                                                <!-- </div> -->
                                                                                <div class="doc-info-cont comment-body">
                                                                                    <h4 class="doc-name"><router-link to="/profile">{{item.nama_to}}</router-link></h4> 
                                                                                    <!-- <div class="rating">
                                                                                        <i class="fas fa-star filled"></i>
                                                                                        <i class="fas fa-star filled"></i>
                                                                                        <i class="fas fa-star filled"></i>
                                                                                        <i class="fas fa-star filled"></i>
                                                                                        <i class="fas fa-star"></i>
                                                                                        <span class="d-inline-block average-rating">{{item.ratings}}</span>
                                                                                    </div> -->
                                                                                    <div class="shop-details" v-if="item.nama_tingkatan">
                                                                                        <p class="doc-location"><i class="fas fa-map-marker-alt"></i> {{item.nama_tingkatan}}</p>
                                                                                        <!-- <p><i class="fas fa-graduation-cap"></i> {{item.courses}}</p> -->
                                                                                    </div>
                                                                                    <!-- <div class="shop-services">
                                                                                        <span>Dorm Living</span>
                                                                                        <span>Diversity & Inclusion</span>
                                                                                        <span>Campus Activities</span>
                                                                                        <span>Student Support</span>
                                                                                    </div> -->
                                                                                </div>
                                                                            </div>
                                                                            <div class="doc-info-right text-center">
                                                                                
                                                                                <div class="table-action">
                                                                                    <button v-if="item.is_periodik == 0 || item.is_dikerjakan < item.is_periodik" class="btn btn-sm btn-rounded btn-primary mb-0.5" @click.prevent="getTryout(item)" data-toggle="modal" data-target="#kerjakanMdl">Kerjakan Soal</button>
                                                                                    <br><button v-if="item.is_dikerjakan > 0" class="btn btn-sm btn-rounded btn-secondary mb-0.5" @click.prevent="getHasilTryout(item)" data-toggle="modal" data-target="#hasilMdl">Hasil Tryout</button>
                                                                                    
                                                                                    <!-- <v-btn class="btn btn-sm bg-warning-light" depressed small @click="getHasilTryout(ref)">
                                                                                        <i class="fas fa-eye"></i> Hasil
                                                                                    </v-btn> -->
                                                                                </div>
                                                                                <!-- <div class="table-action">
                                                                                    <router-link class="btn btn-sm bg-info-light mb-0.5" to="/profile"><i class="fas fa-download"></i> Unduh Materi</router-link>
                                                                                    <router-link class="btn btn-sm bg-primary-light mb-0.5" to="/profile"><i class="fas fa-eye"></i> Lihat Materi</router-link>
                                                                                    
                                                                                </div> -->
                                                                            </div>  
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                
                                                    <div class="col-md-12">
                                                        <hr>
                                                        <div class="comp-header"><h3 class="comp-title">Daftar Tryout Bonus</h3> <div class="line"></div></div>
                                                        <div class="row">
                                                            <div class="col-md-6" v-for="(item, index) in paket.list_tryout" :key="item">
                                                                <div class="card">
                                                                    <div class="card-body">
                                                                        <div class="sender-widget">
                                                                            <div class="doc-info-left comment">
                                                                                <!-- <div class="sender-img"> -->
                                                                                    <img class="avatar rounded-circle" alt="User Image"  v-bind:src="((index+1>=22)?'https://img.icons8.com/color/48/undefined/':'https://img.icons8.com/plasticine/100/000000/')+(index+1)+((index+1>9)?'':'-circle')+'.png'" style="margin-right: 16px;">
                                                                                
                                                                                    <!-- <router-link to="/profile">
                                                                                        <img :src="loadImg(item.image)" class="img-fluid" alt="User Image">
                                                                                    </router-link> -->
                                                                                <!-- </div> -->
                                                                                <div class="doc-info-cont comment-body">
                                                                                    <h4 class="doc-name"><router-link to="/profile">{{item.nama_to}}</router-link></h4> 
                                                                                    <!-- <div class="rating">
                                                                                        <i class="fas fa-star filled"></i>
                                                                                        <i class="fas fa-star filled"></i>
                                                                                        <i class="fas fa-star filled"></i>
                                                                                        <i class="fas fa-star filled"></i>
                                                                                        <i class="fas fa-star"></i>
                                                                                        <span class="d-inline-block average-rating">{{item.ratings}}</span>
                                                                                    </div> -->
                                                                                    <div class="shop-details" v-if="item.nama_tingkatan">
                                                                                        <p class="doc-location"><i class="fas fa-map-marker-alt"></i> {{item.nama_tingkatan}}</p>
                                                                                    </div>
                                                                                    <!-- <div class="shop-services">
                                                                                        <span>Dorm Living</span>
                                                                                        <span>Diversity & Inclusion</span>
                                                                                        <span>Campus Activities</span>
                                                                                        <span>Student Support</span>
                                                                                    </div> -->
                                                                                </div>
                                                                            </div>
                                                                            <div class="doc-info-right text-center">
                                                                                
                                                                                <div class="table-action">
                                                                                    <button class="btn btn-sm btn-rounded btn-primary mb-0.5" @click.prevent="getTryout(item)" data-toggle="modal" data-target="#kerjakanMdl">Kerjakan Soal</button>
                                                                                    <br><button class="btn btn-sm btn-rounded btn-secondary mb-0.5" @click.prevent="getHasilTryout(item)" data-toggle="modal" data-target="#hasilMdl">Hasil Tryout</button>
                                                                                    
                                                                                </div>
                                                                                <!-- <div class="table-action">
                                                                                    <router-link class="btn btn-sm bg-info-light mb-0.5" to="/profile"><i class="fas fa-download"></i> Unduh Materi</router-link>
                                                                                    <router-link class="btn btn-sm bg-primary-light mb-0.5" to="/profile"><i class="fas fa-eye"></i> Lihat Materi</router-link>
                                                                                    
                                                                                </div> -->
                                                                            </div>  
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            
                                            </div>
                                            
                                            <!-- Business Hours Content -->
                                            <div role="tabpanel" id="tabjadwal" class="tab-pane fade"   :class="{'show active' : idtab == 'tabjadwal'}" >
                                                
                                                <div class="row">
                                                    <div class="col-md-6"  v-for="(ref, index) in paket.list_jadwal" :key="ref">
                                                        <!-- {{randomLabel(index)}} -->
                                                        <div class="kt-widget2  box-shadow" >
                                                            <div class="kt-widget2__item " :class="['kt-widget2__item--'+labelBox[(index%4)+1]]" >
                                                                <div class="kt-widget2__info">
                                                                    <div class="kt-widget2__checkbox">
                                                                    </div>
                                                                    <a href="#" class="kt-widget2__title">
                                                                        {{ref.judul_pertemuan}}
                                                                    </a>
                                                                    <a href="#" class="kt-widget2__username">
                                                                        by {{ref.nama_coach}}
                                                                    </a>
                                                                    <a href="#" class="kt-widget2__username">
                                                                        <span class=" text-info">{{ref.jadwal_pertemuan_date}} - {{ref.jadwal_pertemuan_time}}</span>
                                                                    </a>
                                                                </div>
                                                                <a href="#" class="btn btn-sm btn-bold dropdown-toggle" :class="['btn-label-'+labelBox[(index%4)+1]]" data-toggle="dropdown" aria-expanded="false">
                                                                    Start
                                                                </a>
                                                                <div class="dropdown-menu dropdown-menu-fit dropdown-menu-right" x-placement="bottom-end" style="position: absolute; transform: translate3d(180px, 40px, 0px); top: 0px; left: 0px; will-change: transform;">
                                                                    <ul class="kt-nav">
                                                                        
                                                                        <li class="kt-nav__item" v-if="(ref.pretest != '-' && ref.pretest >0 )">
                                                                            <a @click.prevent="getToJadwal(ref,1)" data-toggle="modal" data-target="#toJadwalMdl" class="kt-nav__link">
                                                                                <i class="kt-nav__link-icon fas fa-swatchbook text-sm"></i> 
                                                                                <span class="kt-nav__link-text text-xs">Pre Test</span>
                                                                            </a>
                                                                        </li>
                                                                        <li class="kt-nav__item" v-if="(ref.link_pertemuan != '-' && ref.link_pertemuan != '' ) && ref.status_jadwal!='1'">
                                                                            <a :href="ref.link_pertemuan" target="_blank" class="kt-nav__link">
                                                                                <i class="kt-nav__link-icon fas fa-video text-sm"></i> 
                                                                                <span class="kt-nav__link-text text-xs">Link Pertemuan</span>
                                                                            </a>
                                                                        </li>
                                                                        <li class="kt-nav__item" v-if="(ref.link_rekaman != '-' && ref.link_rekaman != '' )">
                                                                            <a :href="ref.link_rekaman" target="_blank" class="kt-nav__link">
                                                                                <i class="kt-nav__link-icon fas fa-eye text-sm"></i> 
                                                                                <span class="kt-nav__link-text text-xs">Rekaman</span>
                                                                            </a>
                                                                        </li>
                                                                        <li class="kt-nav__item" v-if="(ref.link_materi != '-' && ref.link_materi != '' )">
                                                                            <a :href="ref.link_materi" target="_blank" class="kt-nav__link">
                                                                                <i class="kt-nav__link-icon fas fa-book-open text-sm"></i> 
                                                                                <span class="kt-nav__link-text text-xs">Materi</span>
                                                                            </a>
                                                                        </li>
                                                                        <li class="kt-nav__item" v-if="(ref.posttest != '-' && ref.posttest > 0 )">
                                                                            <a @click.prevent="getToJadwal(ref,2)" data-toggle="modal" data-target="#toJadwalMdl" class="kt-nav__link">
                                                                                <i class="kt-nav__link-icon fas fa-edit text-sm"></i> 
                                                                                <span class="kt-nav__link-text text-xs">Post Test</span>
                                                                            </a>
                                                                        </li>
                                                                        <li class="kt-nav__item" v-if="ref.is_dikerjakan > 0">
                                                                            <a @click.prevent="getHasilTryout(ref)" data-toggle="modal" data-target="#hasilMdl" class="kt-nav__link">
                                                                                <i class="kt-nav__link-icon fas fa-list text-sm"></i> 
                                                                                <span class="kt-nav__link-text text-xs">Hasil Latihan</span>
                                                                            </a>
                                                                        </li>
                                                                        <!-- <li class="kt-nav__item">
                                                                            <a href="#" class="kt-nav__link">
                                                                                <i class="kt-nav__link-icon flaticon2-avatar"></i>
                                                                                <span class="kt-nav__link-text">Members</span>
                                                                            </a>
                                                                        </li>
                                                                        <li class="kt-nav__item">
                                                                            <a href="#" class="kt-nav__link">
                                                                                <i class="kt-nav__link-icon flaticon2-settings"></i>
                                                                                <span class="kt-nav__link-text">Settings</span>
                                                                            </a>
                                                                        </li> -->
                                                                    </ul>
                                                                </div>
                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <!-- /Business Hours Content -->
                                            
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-if="isDetailMateri">
                                <div class="row">
                                    <div class="col-md-12 col-lg-4 col-xl-3 theiaStickySidebar">
                                    
                                        <div class="profile-sidebar">
                                            <div class="widget-profile pro-widget-content">
                                                <div class="profile-info-widget">
                                                    <div class="profile-det-info">
                                                        <h3>{{materi.nama_materi}}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="dashboard-widget">
                                                <nav class="dashboard-menu">
                                                    <ul>   
                                                        <li v-for="(item) in lstsubmateri" :key="item">
                                                             <a href="" @click.prevent="getDetailMateri(item)">
                                                                <i class="fas fa-list"></i>
                                                                <span>{{item.nama_sub_materi}}</span>
                                                            </a>           
                                                            <!-- <button  @click.prevent="getDetailMateri(item)">   
                                                                    <i class="fas fa-list"></i> {{item.nama_sub_materi}}
                                                            </button> -->
                                                        </li>	
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-8 col-xl-9">
                                        <div class="card" v-if="!lstsubdtlmateri.length">
                                             <div class="card-header">
                                                <h4 class="card-title">Silahkan pilih materi...</h4>
                                            </div>
                                        </div>
                                        <div class="card" :style="{'min-height:400px':item.materi_preview}"  v-for="(item) in lstsubdtlmateri" :key="item">
                                             <div class="card-header">
                                                <h4 class="card-title">{{item.nama_judul}} 
                                                 <!-- <div class="col-auto text-right float-right ml-auto"  v-if="item.youtube_id">
                                                    <a class="btn btn-primary btn-sm" :href="item.youtube_id" target="_blank">Lihat Video</a>
                                                </div> -->
                                                </h4>
                                            </div>
                                            <div class="text-center" style="padding-bottom:10px" v-if="item.url_file">
                                                <br>
                                                <a class="btn btn-primary btn-xs" :href="item.url_file" target="_blank">Download Materi</a>
                                                
                                            </div>
                                            <div class="card-body" style="padding:10px" v-if="item.youtube_id">
                                                <div class="col-12 text-center">
                                                    <LazyYoutube
                                                    ref="youtubeLazyVideo"
                                                    :src="item.youtube_id"
                                                    max-width="600px"
                                                    aspect-ratio="16:9"
                                                    thumbnail-quality="standard"
                                                    />
                                                </div>
                                            </div>
                                            <div v-if="item.youtube_id" class="or-line"></div>

                                            <div class="card-body" style="padding:50px" v-html="item.materi_preview" v-if="item.materi_preview">
                                            </div>
                                           
                                        </div>
                                        
                                    </div>
                                </div>

<!-- 
                                <div class="row">
                                    <div class="col-md-12 col-lg-4 col-xl-3 theiaStickySidebar">
                                    
                                        <div class="card search-filter" style="min-height:400px">
                                            <div class="card-header">
                                                <h4 class="card-title mb-0">{{materi.nama_materi}}</h4>
                                            </div>
                                            <div class="card-body profile-sidebar">
                                                <div class="dashboard-widget">
                                                    <nav class="dashboard-menu">
                                                        <ul>
                                                            <li v-for="(item) in lstsubmateri" :key="item">
                                                                
                                                            <button  @click.prevent="getDetailMateri(item)">   
                                                                    <i class="fas fa-list"></i> {{item.nama_sub_materi}}
                                                                </button>
                                                            </li>	
                                                        </ul>
                                                    </nav>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="col-md-12 col-lg-8 col-xl-9">

                                        <div class="card" style="min-height:400px"  v-for="(item) in lstsubdtlmateri" :key="item">
                                             <div class="card-header">
                                                <h4 class="card-title">{{item.nama_judul}} 
                                                 <div class="col-auto text-right float-right ml-auto"  v-if="item.url_file">
                                                    <a class="btn btn-primary btn-sm" :href="item.url_file" target="_blank">Download Materi</a>
                                                </div>
                                                </h4>
                                            </div>
                                            <div class="card-body" style="padding:50px" v-html="item.materi_preview">
                                            </div>
                                           
                                        </div>
                                        
                                    </div>
                                </div> -->

                               
                            </template>
                            
                            
						</div>
                    </div>

				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
                <layout-footer />
			<!-- /Footer -->
		</div>
	

        <div id="kerjakanMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hai, apakah kamu sudah siap mengerjakan Latihan ini?</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <br>
                        <table class="table">
                            <tr>
                                <td>Latihan</td>
                                <td v-if="tryout.nama_to">{{tryout.nama_to}}</td>
                                <td v-if="tryout.judul_pertemuan">{{tryout.judul_pertemuan}}</td>
                            </tr>
                            <tr v-if="tryout.nama_materi">
                                <td>Kategori</td>
                                <td>{{tryout.nama_materi}} / {{tryout.nama_sub_materi}}</td>
                            </tr>
                            <tr>
                                <td>Jumlah Soal</td>
                                <td>{{tryout.jumlah_soal}} Soal</td>
                            </tr>
                            <tr>
                                <td>Waktu Mengerjakan</td>
                                <td>{{tryout.waktu}} menit</td>
                            </tr>
                        </table>
                        <br>
                        <div role="alert" class="alert alert-warning">
                            <div class="col-auto">
                                <strong class="ml-0"><i class="fa fa-info-circle"></i> Perhatian!</strong><br>
                                <ol class="mb-0">
                                    <li>Gunakan browser Google Chrome versi terbaru supaya website dapat diakses dengan lancar tanpa masalah.</li>
                                    <li>Pastikan tidak ada aktivitas login ke akun anda (pada perangkat lain) saat sedang mengerjakan tryout.</li>                       
                                </ol>
                            </div>
						</div>
                    </div>

                    <div class="modal-footer">    
                        <button class="btn btn-rounded btn-primary" data-dismiss="modal" @click.prevent="doTryout()" v-if="tryout.is_periodik == 0 || (tryout.is_dikerjakan < tryout.is_periodik)" ><i class="fa fa-user-edit"></i> Kerjakan Sekarang</button>                    
                        <!-- <button class="btn btn-rounded btn-primary" data-dismiss="modal" @click.prevent="doTryout()" v-if="tryout.is_periodik == 0 || tryout.is_dikerjakan < tryout.is_periodik" ><i class="fa fa-user-edit"></i> Kerjakan Sekarang</button> -->
                        
                    </div>

                </div>
            </div>
        </div>


        <div id="rankingPaketMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hasil Pengerjaan Paket {{paket.nama_paket}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive">
                            <table id="tblHasil" class="table table-hover table-striped table-center mb-0">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th class="text-left">Nama Tryout</th>
                                        <th class="text-center">Rata-rata Nilai</th>
                                    </tr>
                                </thead>
            
                                <tbody>
                                    <tr v-for="(ref, index) in paket.list_nilai_tryout" :key="ref.id_to">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ ref.nama_to }}</td>
                                        <td class="text-center">{{ ref.nilaiTo }}</td>
                                    </tr>
                                    <!-- <tr>
                                        <th colspan="2" class="text-right">Total Skor</th>
                                        <th class="text-center">{{paket.nilai.totNilai}}</th>
                                    </tr>
                                    <tr class="bg-warning">
                                        <th colspan="2" class="text-right">Peringkat</th>
                                        <th class="text-center">{{paket.rankingPaket}}</th>
                                    </tr> -->
                                    <!-- <tr>
                                        <th colspan="2" class="text-right">Skor Rata-rata</th>
                                        <th class="text-center">{{paket.nilai.rataNilai}}</th>
                                    </tr> -->
                                </tbody>                                            
                            </table>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

        
        <div id="hasilMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hasil pengerjaan Tryout {{tryout.nama_to}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                         <nav class="user-tabs mb-4">
                            <ul class="nav nav-tabs nav-tabs-bottom nav-justified">
                                <li class="nav-item">
                                    <a class="nav-link active" href="#tabstatistik" data-toggle="tab">Statistik</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#tabpembahasan" data-toggle="tab">Pembahasan</a>                                                
                                </li>  
                            </ul>
                        </nav>
            
                        <div class="tab-content pt-0">
                            
                            <!-- Tingkatan Tab -->
                            <div id="tabstatistik" class="tab-pane fade show active">
                                <div class="card card-table mb-0">
                                    <section class="benefits-section" style="background: #edecf2 !important;">
				                        <div class="custom-container">
                                            <div class="row justify-content-center">  
                                                                                
                                                <div class="col-md-6 col-sm-6 col-12 col-lg">
                                                    <div class="benefit-widget benefit-widget-clr3" style="min-height: 250px !important;">
                                                        <h2>Skor Akhir</h2>
                                                        <template v-if="tryout.nilai != null">
                                                            <p>{{tryout.nilai.nilaiuser}} dari {{tryout.nilai.total}}</p>
                                                            <span class="clr-blue">{{tryout.lbl_hasil}}</span>
                                                        </template>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-sm-6 col-12 col-lg">
                                                    <div class="benefit-widget benefit-widget-clr2" style="min-height: 250px !important;">
                                                        <h2>Detail Skor</h2>
                                                        <template v-if="tryout.nilai != null" >
                                                            <div v-for="(ref) in lsthasilpg" :key="ref.jns_kategori">
                                                                <p v-if="ref.jns_kategori!=null">Skor {{ref.jns_kategori}}: {{ref.pguser}} (Passing Grade {{ref.pg}})</p>
                                                            </div>
                                                        <!-- <p>Skor TWK: {{tryout.nilai.o_twk}} (Passing Grade {{tryout.nilai.pg_twk}})</p>
                                                        <p>Skor TIU: {{tryout.nilai.o_tiu}} (Passing Grade {{tryout.nilai.pg_tiu}})</p>
                                                        <p>Skor TKP: {{tryout.nilai.o_tkp}} (Passing Grade {{tryout.nilai.pg_tkp}})</p> -->
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                            <!-- Tingkatan Tab -->
                            <div id="tabpembahasan" class="tab-pane">
                                <div class="card card-table mb-0">
                                    
                                    <div class="table-responsive">
                                        <table id="tblHasil" class="table table-hover table-center mb-0">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">#</th>
                                                    <th class="text-left">Tanggal</th>
                                                    <th class="text-center">Nilai</th>
                                                    <th class="text-center">Waktu</th>
                                                    <th class="text-center">Rank</th>
                                                    <th class="text-center">Action</th>
                                                </tr>
                                            </thead>
                        
                                            <tbody>
                                                <tr v-for="(ref, index) in lsthasil" :key="ref.id_user_to">
                                                    <td>{{ index + 1 }}</td>
                                                    <td>{{ ref.created_date }}</td>
                                                    <td class="text-center">{{ ref.hasil }}</td>
                                                    <td class="text-center">{{ ('0' + parseInt(parseInt(tryout.waktu) - (parseInt(ref.waktu)/60))).slice(-2) + ':' + ('0' + ((parseInt(tryout.waktu)*60)-parseInt(ref.waktu))%60).slice(-2) }}</td>
                                                    <!-- <td class="text-center">{{ parseInt(parseInt(tryout.waktu) - (parseInt(ref.waktu)/60)) + ':' + ((parseInt(tryout.waktu)*60)-parseInt(ref.waktu))%60 }}</td> -->
                                                    <td class="text-center">{{ ref.ket }}</td>
                                                    <!-- <td class="text-center">{{ parseInt(((parseInt(tryout.waktu)*60) - parseInt(ref.waktu))/60) + ':' +  Math.round(((tryout.waktu*60) -  parseInt(((tryout.waktu*60) - ref.waktu)/60) ) * 60)}}</td> -->
                                                    
                                                    <td>
                                                        <v-btn v-if="tryout.is_active=='1'" class="btn btn-sm bg-success-light" depressed small @click="getPembahasan(ref)" data-dismiss="modal" aria-label="Close" id="hasilMdl" data-target="#hasilMdl">
                                                            <i class="fas fa-eye"></i> Pembahasan
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                                <!-- <tr>
                                                    <td colspan="2" class="text-right">Rata-rata Nilai</td>
                                                    <td class="text-center">{{tryout.rataNilai}}</td>
                                                    <td colspan="3"></td>
                                                </tr> -->
                                            </tbody>                                            
                                        </table>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>

        
        <div id="toJadwalMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{tryout.nama_to}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeToJadwal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <nav class="user-tabs mb-4">
                            <ul class="nav nav-tabs nav-tabs-bottom nav-justified">
                                <li class="nav-item">
                                    <a class="nav-link active" href="#kerjakanlatihan" data-toggle="tab"><span class="med-records">Kerjakan Latihan</span></a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#hasillatihan" data-toggle="tab">Hasil Latihan</a>
                                </li> 
                            </ul>
                        </nav>
                        <!-- /Tab Menu -->
                        
                        <!-- Tab Content -->
                        <div class="tab-content pt-0">
                                    
                            <div id="kerjakanlatihan" class="tab-pane fade card show active">
                                
                                <div class="card-header">
                                    <h4 class="modal-title">Hai, apakah kamu sudah siap mengerjakan Latihan ini?</h4>
                                   
                                </div>
                                <div class="card-body">
                                    <br>
                                    <table class="table">
                                        <tr>
                                            <td>Latihan</td>
                                            <td>{{tryout.nama_to}}</td>
                                        </tr>
                                        <tr v-if="tryout.nama_materi">
                                            <td>Kategori</td>
                                            <td>{{tryout.nama_materi}} / {{tryout.nama_sub_materi}}</td>
                                        </tr>
                                        <tr>
                                            <td>Jumlah Soal</td>
                                            <td>{{tryout.jumlah_soal}} Soal</td>
                                        </tr>
                                        <tr>
                                            <td>Waktu Mengerjakan</td>
                                            <td>{{tryout.waktu}} menit</td>
                                        </tr>
                                    </table>
                                    <br>
                                    <div role="alert" class="alert alert-warning">
                                        <div class="col-auto">
                                            <strong class="ml-0"><i class="fa fa-info-circle"></i> Perhatian!</strong><br>
                                            <ol class="mb-0">
                                                <li>Gunakan browser Google Chrome versi terbaru supaya website dapat diakses dengan lancar tanpa masalah.</li>
                                                <li>Pastikan tidak ada aktivitas login ke akun anda (pada perangkat lain) saat sedang mengerjakan tryout.</li>                       
                                            </ol>
                                        </div>
                                    </div>
                                </div>

                                <div class="card-footer text-center">                        
                                    <button class="btn btn-rounded btn-primary" data-dismiss="modal" @click.prevent="doTryout()"><i class="fa fa-user-edit"></i> Kerjakan Sekarang</button>
                                    
                                </div>
                            </div>
                            <div id="hasillatihan" class="tab-pane fade ">
                                
                                <div class="table-responsive">
                                    <table id="tblHasil" class="table table-hover table-center mb-0">
                                        <thead>
                                            <tr>
                                                <th class="text-left">#</th>
                                                <th class="text-left">Tanggal</th>
                                                <th class="text-left">Nilai</th>
                                                <th class="text-left">Waktu</th>
                                                <th class="text-center">Rank</th>
                                                <th class="text-left">Action</th>
                                            </tr>
                                        </thead>
                    
                                        <tbody>
                                            <tr v-for="(ref, index) in lsthasil" :key="ref.id_user_to">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ ref.created_date }}</td>
                                                <td class="text-center">{{ ref.hasil }}</td>
                                                <td class="text-center">{{ ('0' + parseInt(parseInt(tryout.waktu) - (parseInt(ref.waktu)/60))).slice(-2) + ':' + ('0' + ((parseInt(tryout.waktu)*60)-parseInt(ref.waktu))%60).slice(-2) }}</td>
                                                <td class="text-center">{{ ref.ket }}</td>
                                                <!-- <td class="text-center">{{ parseInt(parseInt(tryout.waktu) - (parseInt(ref.waktu)/60)) + ':' + ((parseInt(tryout.waktu)*60)-parseInt(ref.waktu))%60 }}</td> -->
                                                <!-- <td class="text-center">{{ parseInt(((parseInt(tryout.waktu)*60) - parseInt(ref.waktu))/60) + ':' +  Math.round(((tryout.waktu*60) -  parseInt(((tryout.waktu*60) - ref.waktu)/60) ) * 60)}}</td> -->
                                                
                                                <td>
                                                    <v-btn v-if="tryout.is_active=='1'" class="btn btn-sm bg-success-light" depressed small @click="getPembahasan(ref)" data-dismiss="modal" aria-label="Close" id="hasilMdl" data-target="#hasilMdl">
                                                        <i class="fas fa-eye"></i> Pembahasan
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </tbody>                                            
                                    </table>
                                    
                                </div>

                            </div>
                        </div> 
                    
                    </div>
                </div>
            </div>
        </div>


	</div>
		<!-- /Main Wrapper -->
</template>


<script>
// import instructors from '../../../assets/json/instructorslist'
// const images = require.context('@/assets/img/clients', false, /\.png$|\.jpg$/)
// import schoolvisits from '../../../assets/json/instructor/dashboard/schoolvisits'
// import coursetakenrecords from '../../../assets/json/instructor/dashboard/coursetakenrecords'
// import billing from '../../../assets/json/instructor/dashboard/billing'

import Sidebar from '../../Sidebar'
import axios from 'axios';
import store from '../../../../store'
// import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
// import $ from 'jquery';
import LazyTube from "vue-lazytube"

export default {
    components: {
        Sidebar
    },
	name: 'paket-saya-detail',
    // vuetify: new Vuetify(),
    data() {
        return {
            isShowMain: true,
            isDetailMateri: false,
            idtab: 'tabmateri',
            tabactive: 'DAFTAR MATERI',
            materi: [],
            lstsubmateri: [],
            dtlsubmateri: [],
            alreadyFinish: false,            
            lsthasil:[],         
            lsthasilpg:[],
            paket:{
                id_paket: '',
                nama_paket: '',
                tipe_paket: '',
                harga_awal: '',
                diskon: '',
				harga_aktif: '',
                masa_berlaku: '',
				jml_to: '',
                diskon_referral: '',
                komisi_referral: '',
                url_gambar: '',
                fg_publish: '',
                fg_pendaftaran: '',
                fg_favorit: '',
                url_telegram: '',
                slot: '',
                materipct: 0,
                topct: 0,
            },
            lsttipe: [
                {id: '1', text: 'MANDIRI'},
                {id: '2', text: 'BIMBEL'}
            ],
            lststspublish: [
                {id: '1', text: 'DRAFT'},
                {id: '2', text: 'PUBLISH'}
            ],
            lststspendaftaran: [
                {id: '1', text: 'DITUTUP'},
                {id: '2', text: 'DIBUKA'}
            ],
            lststsfav: [
                {id: '1', text: 'TIDAK'},
                {id: '2', text: 'YA'}
            ],
            lstsubdtlmateri: [],
            subdtlmateri: {
                id_judul: '',
                nama_judul: '',
                hak_akses: '',
                tanggal_materi: '',
                kategori: '',
                subject: '',
                tipe_coach: '',
                nama_coach: '',
                youtube_id: '',
                url_file: '',
                already_read: '0'
            },
            tryout: {
                id_to: '',
                nama_to: '',
                id_tingkatan: '',
                id_materi: '',
                id_sub_materi: '',
                url: '',
                waktu: '',
                fg_publish: '',
                nilai:{total: '',
                        nilaiuser: '',
                        // pg_twk: '',
                        // o_twk: '',
                        // pg_tiu: '',
                        // o_tiu: '',
                        // pg_tkp: '',
                        // o_tkp: ''
                        },
                lbl_hasil: ''
            },            
            active: false,
            show: false,
            labelBox: [
                "brand", "warning","danger","success","primary"
            ],
            curlabel:'', curbtn:'',
            defnilai:{total: '',
                        nilaiuser: '',
                        // pg_twk: '',
                        // o_twk: '',
                        // pg_tiu: '',
                        // o_tiu: '',
                        // pg_tkp: '',
                        // o_tkp: ''
                        }
			// lstbenefit: [],
			// lstjadwal: [],
			// lsttryout: [],
			// paketlsttryout: [],
			// lstmateri: [],
			// paketlstmateri: [],
           
        }
    },
    created: function () {
        // this.refreshAll();
        
        // this.getPaket();
        // this.initBar();
        // this.getAllMateri();
        // this.getAllSub();
        // this.initDt("tblMateri");
        // this.initDt("tblSub");

    },  
    
    mounted() {
        if(localStorage.getItem('token')){
            store.dispatch("checktoken");
        }
        this.getPaket();
        // if(('.circle-bar').length > 0) {
        //     $('.circle-bar1').each(function () {
        //         var elementPos = $(this).offset().top;
        //         var topOfWindow = $(window).scrollTop();
        //         var percent = $(this).find('.circle-graph1').attr('data-percent');
        //         var animate = $(this).data('animate');
        //         if (elementPos < topOfWindow + $(window).height() - 30 && !animate) {
        //             $(this).data('animate', true);
        //             $(this).find('.circle-graph1').circleProgress({
        //                 value: percent / 100,
        //                 size : 400,
        //                 thickness: 30,
        //                 fill: {
        //                     color: '#da3f81'
        //                 }
        //             });
        //         }
        //     });
        //     $('.circle-bar2').each(function () {
        //         var elementPos = $(this).offset().top;
        //         var topOfWindow = $(window).scrollTop();
        //         var percent = $(this).find('.circle-graph2').attr('data-percent');
        //         var animate = $(this).data('animate');
        //         if (elementPos < topOfWindow + $(window).height() - 30 && !animate) {
        //             $(this).data('animate', true);
        //             $(this).find('.circle-graph2').circleProgress({
        //                 value: percent / 100,
        //                 size : 400,
        //                 thickness: 30,
        //                 fill: {
        //                     color: '#e9ab2e'
        //                 }
        //             });
        //         }
        //     });
        //     $('.circle-bar3').each(function () {
        //         var elementPos = $(this).offset().top;
        //         var topOfWindow = $(window).scrollTop();
        //         var percent = $(this).find('.circle-graph3').attr('data-percent');
        //         var animate = $(this).data('animate');
        //         if (elementPos < topOfWindow + $(window).height() - 30 && !animate) {
        //             $(this).data('animate', true);
        //             $(this).find('.circle-graph3').circleProgress({
        //                 value: percent / 100,
        //                 size : 400,
        //                 thickness: 30,
        //                 fill: {
        //                     color: '#1b5a90'
        //                 }
        //             });
        //         }
        //     });
        // }
    },

    methods: {
        // toggleModal() {
        //     const body = document.querySelector("body");
        //     this.active = false;//!this.active;
        //     this.active
        //         ? body.classList.add("modal-open")
        //         : body.classList.remove("modal-open");
        //     setTimeout(() => (this.show = !this.show), 10);
        // },
        randomLabel : function(idx){
            // const index = (idx> Math.ceil(Math.random()*4);
            // console.log(index);
            // this.curindex = (this.curindex==4)?0:this.curindex+1;
            this.curlabel = 'kt-widget2__item--'+this.labelBox[(idx%4)+1];
            this.curbtn = 'btn-label-'+this.labelBox[(idx%4)+1];
            // console.log(this.curlabel);
        },
        setGrafik: function (paket) {
            if(('.circle-bar').length > 0) {
                $('.circle-bar1').each(function () {
                    var elementPos = $(this).offset().top;
                    var topOfWindow = $(window).scrollTop();
                    var percent = $(this).find('.circle-graph1').attr('data-percent'); //paket.materipct; 
                    var animate = $(this).data('animate');
                    if (elementPos < topOfWindow + $(window).height() - 30 && !animate) {
                        $(this).data('animate', true);
                        $(this).find('.circle-graph1').circleProgress({
                            value: percent / 100,
                            size : 400,
                            thickness: 30,
                            fill: {
                                color: '#da3f81'
                            }
                        });
                    }
                });
                $('.circle-bar2').each(function () {
                    var elementPos = $(this).offset().top;
                    var topOfWindow = $(window).scrollTop();
                    var percent = $(this).find('.circle-graph2').attr('data-percent'); //paket.topct; 
                    // var percent = $(this).find('.circle-graph2').attr('data-percent');
                    var animate = $(this).data('animate');
                    if (elementPos < topOfWindow + $(window).height() - 30 && !animate) {
                        $(this).data('animate', true);
                        $(this).find('.circle-graph2').circleProgress({
                            value: percent / 100,
                            size : 400,
                            thickness: 30,
                            fill: {
                                color: '#e9ab2e'
                            }
                        });
                    }
                });
                $('.circle-bar3').each(function () {
                    var elementPos = $(this).offset().top;
                    var topOfWindow = $(window).scrollTop();
                    var percent = $(this).find('.circle-graph3').attr('data-percent');
                    var animate = $(this).data('animate');
                    if (elementPos < topOfWindow + $(window).height() - 30 && !animate) {
                        $(this).data('animate', true);
                        $(this).find('.circle-graph3').circleProgress({
                            value: percent / 100,
                            size : 400,
                            thickness: 30,
                            fill: {
                                color: '#1b5a90'
                            }
                        });
                    }
                });
            }
        },
        getPaket: function () {
            axios.get('api/paketsaya/'+localStorage.getItem("idUser")+'/'+localStorage.getItem("idPaket"))//this.$route.params.idPaket)
                .then(res => {
                    // console.log(res.data);
                    this.paket = res.data.data;
                    this.paket.materipct = (this.paket.finish_materi/this.paket.all_materi)*100;
                    this.paket.topct = (this.paket.finish_to/this.paket.all_to)*100;
                    // console.log(this.paket.materipct);
                    this.setGrafik(this.paket);
                    // this.initDt("tblLatihan");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        getMateri: function (ref) {
            this.isShowMain = false;
            this.isDetailMateri = true;
            axios.get('api/lstsubmateri/'+ref.id_materi)
                .then(res => {
                    // console.log(res.data);
                    this.materi = ref;
                    this.lstsubdtlmateri = [];
                    this.lstsubmateri = res.data.data;
                    // console.log(this.lstsubmateri);
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        
        getDetailMateri: function (ref) {
            // this.isShowMain = false;
            // this.isDetailMateri = true;
            axios.get('api/subdtlmateri/'+ref.id_sub_materi)
                .then(res => {
                    // console.log(res.data);
                    this.lstsubdtlmateri = res.data.data;
                    // this.lstsubmateri = res.data.data;
                    // console.log(this.lstsubmateri);
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        
        downloadMateri: function (ref) {
            // console.log(ref);
                axios.get(ref.url_file, { responseType: 'blob' })
                .then(response => {
                    const blob = new Blob([response.data], { type: 'application/pdf' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = ref.nama_judul
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(console.error)
            
            
            // this.isShowMain = false;
            // this.isDetailMateri = true;
            // axios.get('api/subdtlmateri/'+ref.id_sub_materi)
            //     .then(res => {
            //         console.log(res.data);
            //         this.subdtlmateri = res.data.data;
            //         // this.lstsubmateri = res.data.data;
            //         // console.log(this.lstsubmateri);
            //     })
            //     .catch(err => {
            //         // handle error
            //         console.log(err);
            //     })
        },
        
        finishRead: function (e) {
            // console.log(e.target.checked);
           if(e.target.checked){// || this.subdtlmateri.already_read === "1"){
            axios.post('api/paketsalesmateri', {
                    // id_paket_sales: this.$route.params.idPaketSales,
                    id_user: localStorage.getItem("idUser"),
                    id_paket: localStorage.getItem("idPaket"),
                    id_judul: this.subdtlmateri.id_judul
                })
                .then(res => {
                    // handle success
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
           } else {
               axios.post('api/delpaketsalesmateri', {
                    // id_paket_sales: this.$route.params.idPaketSales,                    
                    id_user: localStorage.getItem("idUser"),
                    id_paket: localStorage.getItem("idPaket"),
                    id_judul: this.subdtlmateri.id_judul
                })
                .then(res => {
                    // handle success
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
           }
        },

        // Get Detail and Show data to Modal
        getTryout: function (ref) {
            // console.log(ref);
            this.tryout = ref;
            // this.tryout.nilai = defnilai;
            // console.log("ini this to:");
            // console.log(this.tryout);
        },


        
        doTryout: function () {
            // $("#kerjakanMdl").modal('hide');  
            
            const lstsoal = localStorage.getItem('lstsoal');
            if(lstsoal){
                localStorage.removeItem('lstsoal');
            }           
            const vtime = localStorage.getItem('time');
            if(vtime){
                localStorage.removeItem('time');
            } 
              
            localStorage.setItem("id_to", this.tryout.id_to);      
            localStorage.setItem("time", this.tryout.waktu*60);      
            this.$router.push({name:'siswa-tryout-try'});
        },


        
        getHasilTryout: function (ref) {
            this.tryout = ref;
            axios.get('api/tryoutres/'+ref.id_to+'/'+ref.id_user)
                .then(res => {
                    // console.log(res.data);
                    // $("#hasilMdl").modal('show');
                    this.lsthasil = res.data.data;
                    this.lsthasilpg = res.data.nilaipg;
                    // this.tryout.rataNilai = res.data.rataNilai;
                    this.tryout.nilai = res.data.nilai;
                    this.tryout.lbl_hasil = res.data.hasilKelulusan;
                    // this.initDt("tblHasil");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        getPembahasan: function (ref) {
            // $("#hasilMdl").modal('hide');   
            localStorage.setItem("id_to", ref.id_to);      
            localStorage.setItem("id_user_to", ref.id_user_to);   
            
            this.$router.push({name:'siswa-tryout-pembahasan'});
        },

        getToJadwal: function (ref, col) {
            axios.get('api/tojadwal/'+ref.id_paket_jadwal+'/'+ref.id_user+'/'+col)
                .then(res => {
                    // console.log(res.data);
                    // $("#hasilMdl").modal('show');
                    this.tryout = res.data.data.tryout;
                    // this.clear("tblHasil");
                    this.lsthasil = res.data.data.lsthasil;
                    // this.initDt("tblHasil");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Siswa/PaketSaya/Detail/index.vue